var shareContactSeekConsentModule = angular.module('shareContactSeekConsentModule', []);

shareContactSeekConsentModule.controller('ContactDetailsModalController', ['$scope', 'Loading', 'contactDetailsService', '$rootScope',
	function ($scope, Loading, contactDetailsService, $rootScope) {
		$scope.loading = false;
		$scope.recipients = null;
		$scope.resumeName = null;
		$scope.resumeSize = null;
		$scope.downloadResumeUrl = null;

		$scope.scopeInit = function () {
			$scope.shareData = {
				eIDs: [],
				others: [],
				includes: [],
				resumeChecked: true
			};

			//TODO-PRANAV: Default text for subject and message for Share Contact. 
			$scope.shareData.message = "I'm sharing [contact-first-name] [contact-last-name]'s profile below for your thoughts. \nPlease reply to this email with your comments. You can reply directly to this message to add a comment regarding [contact-first-name] [contact-last-name].\n\n[sender-first-name] [sender-last-name]";
			$scope.shareData.subject = "Sharing [contact-first-name] [contact-last-name]'s profile for your thoughts.";
		};

		$scope.scopeInit();

		$scope.$watch('shareData.addUser', function (userType) {
			if (angular.isArray(userType) && userType.length === 0) {
				$scope.shareData.addUser = '';
			}
		});

		$scope.$on('SHARE_CONTACT_HIDING_MODAL', function (event) {
			$scope.submitted = false;
			$scope.scopeInit();
			$scope.shareContactForm.$setPristine();
		});

		var contactEid = window.JV.CONTACT_IDS;
		//Spoke to Carlos and Ali. Removing the option to download the resume. More corner cases to cover in that case. 
		// TODO-PRANAV: Remove this later on.
		// var args={
		// action:'getShareContactResume',
		// ids: contactEid
		// }

		$scope.save = function () {
			if ($scope.shareContactForm.$invalid) {
				return;
			}
			var _emailArray = [];

			if ($scope.shareData.resumeChecked) $scope.shareData.includes.push('RESUME');
			if ($scope.shareData.messageChecked) $scope.shareData.includes.push('MESSAGES');
			if ($scope.shareData.notesChecked) $scope.shareData.includes.push('NOTES');

			if ($scope.shareData.otherRecipients !== undefined) $scope.shareData.others = $scope.shareData.otherRecipients.split(',');

			angular.forEach($scope.shareData.addUser, function (val, key) {
				var emailPattern = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
				if (emailPattern.test(val.EId))
					_emailArray.push(val.EId);
				else
					$scope.shareData.eIDs.push(val.EId);
			});

			var args = {
				action: 'shareContact',
				ids: contactEid,
				recipientEId: $scope.shareData.eIDs,
				recipientEmail: $scope.shareData.others,
				subject: $scope.shareData.subject,
				include: $scope.shareData.includes,
				message: $scope.shareData.message,
				recipientEmail: _emailArray
			};

			contactDetailsService.getShareContact(args, function (result) {
				if (result.status == 'ok') {
					$scope.$emit('SHARE_CONTACT_MODAL_HIDE_ALL', 'HIDE_ALL');

					// Make a call to the DetailsTab Class to get the shareHistory data
					// and to populate the UI. This Class already exists and we would
					// have to rewrite the endpoint and shareHistory setup to get the
					// content returned as JSON to be rendered via Angular
					DetailsTab.prototype.getShareHistory(0);

					window.JV.Util.showMessage(i18n['JV_CONTACTDETAILSMODAL_CTRL_THE_CONTACT_HAS_BEEN_SHARED']);
				} else {
					window.JV.Util.showMessage('Some error occurred. The contact has not been shared');
				}
				$scope.scopeInit();
				$scope.shareContactForm.$setPristine();
				$scope.submitted = false;
			});
		};
	}
]);



/**
 * reusing message modal for seek consent
 */
shareContactSeekConsentModule.controller('addSeekConsentMessageController', ['$scope', 'Loading', 'contactDetailsService', '$rootScope',
	function ($scope, Loading, contactDetailsService, $rootScope) {

		var contactEid = window.JV.CONTACT_IDS;

		$scope.scopeInit = function () {
			$scope.seekConsent = {};
			$scope.seekConsent.messageTemplates = {};
			$scope.loadMessageTemplates();
		};

		$scope.loadMessageTemplates = function () {
			var args = {
				action: 'getMessageTemplates',
				ids: contactEid,
				resourceTypeId: 277
			};

			contactDetailsService.getEmailTemplatesForSeekConsent(args, function (result) {
				if (result.status === 'ok') {
					$scope.seekConsent.messageTemplates = selectDefaultTemplate(JSON.parse(result.resultList));
				}
			});
		};

		$scope.scopeInit();
		$scope.loadMessageTemplates();

		$scope.$on('SEEK_CONSENT_HIDING_MODAL', function (event) {
			$scope.submitted = false;
			$scope.scopeInit();
			$scope.seekConsentForm.$setPristine();
		});

		$scope.close = function () {
			$scope.seekConsent.messageTemplates = {};
			$scope.$emit('SEEK_CONSENT_HIDING_MODAL', 'HIDE_ALL');
		};


		var selectDefaultTemplate = function (templates) {
			angular.forEach(templates, function (tpl) {
				setTemplateName(tpl);
				if (tpl.isDefault === true) {
					$scope.seekConsent.messageTpl = tpl;
					$scope.messageContent = tpl.message;
					$scope.messageSubject = tpl.subject;
				}
			});
			return templates;
		};

		// setting the template title as combination of template title and locale
		var setTemplateName = function (template) {
			template.name = template.title + ' - ' + template.locale;
		};

		$scope.save = function () {
			$scope.contentError = ($scope.messageContent === '' || $scope.messageContent == null);
			$scope.subjectError = ($scope.messageSubject === '' || $scope.messageSubject == null);
			if (!$scope.contentError && !$scope.subjectError) {
				var args = {
					action: 'doSeekConsent',
					id: contactEid,
					message: $scope.messageContent,
					subject: $scope.messageSubject
				};

				contactDetailsService.doSeekConsent(args, function (result) {
					if (result.status === 'ok' || result.status === 200) {
						$scope.hideSeekConsentModal();
						window.JV.Util.showMessage(result.data);
					}
				});
			}
		};

		//    actionModalService.getMessageInfo(contactService.messageEids, true, 277, function(results){
		//        var result = results.resultList;
		//        $scope.seekConsent = {};
		//        $scope.seekConsent.messageTemplates = selectDefaultTemplate(results.messageTemplates);
		//
		//        var recipientArray = [];
		//        var invalid = 0;
		//        var unsubscribed = 0;
		//        angular.forEach(result, function(value,key){
		//            var person = " "+value.firstName+" "+value.lastName;
		//            if(value.primaryEmail !== null && value.primaryEmail.name !== ""){
		//                person = person+" <"+value.primaryEmail.name+">";
		//            }
		//            else{
		//                invalid++;
		//            }
		//            recipientArray.push(person);
		//        });
		//        $scope.recipient = recipientArray.join(",");
		//
		//        var total = result.length;
		//        if (invalid > 0){
		//            $scope.invalid = i18n["JV_CONTACTMODAL__0_OF_1_CONTACT_S_DO_NOT_HAVE_A_VALID_EMAIL_ADRESS"].format(invalid, total);
		//        }
		//        if (unsubscribed > 0){
		//            $scope.unsubscribed = i18n["JV_CONTACTMODAL__0_OF_1_CONTACT_S_OPTED_OUT_"].format(unsubscribed, total);
		//        }
		//        if(invalid > 0 || unsubscribed > 0){
		//            $scope.notSent = i18n["JV_CONTACTMODAL_THIS_EMAIL_WILL_NOT_BE_SENT_TO_THEM_"];
		//        }
		//    });
		//
		//    var selectDefaultTemplate = function(templates){
		//        angular.forEach(templates, function(tpl) {
		//            setTemplateName(tpl);
		//            if (tpl.isDefault === true) {
		//                $scope.seekConsent.messageTpl = tpl;
		//                $scope.messageContent = tpl.message;
		//                $scope.messageSubject = tpl.subject;
		//            }
		//        });
		//        return templates;
		//    };
		//
		//    // setting the template title as combination of template title and locale
		//    var setTemplateName = function(template){
		//        template.name=template.title+" - "+template.locale;
		//    }
		//
		//    $scope.save = function (){
		//        $scope.contentError = ($scope.messageContent=="" || $scope.messageContent == null);
		//        $scope.subjectError = ($scope.messageSubject=="" || $scope.messageSubject == null);
		//        if(!$scope.contentError && !$scope.subjectError){
		//            var messageObj = {};
		//            messageObj.message = $scope.messageContent;
		//            messageObj.subject = $scope.messageSubject;
		//            $rootScope.$broadcast('addSeekConsentMessage', messageObj);
		//            $scope.close();
		//        }
		//    };

	}
]);